export const DRAG_DROP_FORMATS = ['gltf', 'glb'];